jQuery(function($) {
  	
  	var name = decodeURIComponent(getUrlVars()["name"]);
  	var name = name.replace("+", " ");
	var email = decodeURIComponent(getUrlVars()["email"]);
  	
if(email != "") {
	ga('send', 'event', {
    	eventCategory: 'Contact Form',
    	eventAction: 'Submit',
    	eventLabel: 'Contact Us - '+ email
	});
}

if(email != empty && name != "") {
	var _lrx_profile = {
		"firstName": name,
		"lastName": "",
		"email": email,
		"leadValue": "",
		"orderID": ""
	};
	_lrx_sendEvent('conversion', 14713, null, JSON.stringify(_lrx_profile));
}
  
});

function getUrlVars()
{
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}